export default __webpack_public_path__ + "static/media/spotify.2b5e9be1.png";